<template>
  <div id="app" :class="{'wb-ba': $i18n.locale == 'zh-CN'}">
    <router-view />
  </div>
</template>

<script>
  import i18next from 'i18next';
  import Vue from 'vue';

  export default {
    name: 'App',
    data() {
      return {}
    },
    created() {
      this.setLanguage();
    },
    mounted() {
      window.addEventListener("resize", () => {
        this.bus.$emit('onResize', document.body.clientWidth, document.body.clientHeight);
      })
      if (this.$utils.isLogin()) {
        if (localStorage.getItem("isFristLogin") != '1') {
          this.getMenuRounters();
          // this.getMyUserInfo();
          this.getRoutersMenu();
        } else {
          localStorage.setItem("isFristLogin", "0");
        }
      }
    },
    methods: {
      /**
       * 设置语言
       */
      setLanguage() {
        var language = localStorage.getItem("language");
        if (language) {
          var language = this.$utils.getDefaultLanguage(language);
          this.$i18n.locale = language;
          i18next.changeLanguage(language);
        } else {
          var language = this.$utils.getDefaultLanguage();
          this.$i18n.locale = language;
          i18next.changeLanguage(language);
        }
        localStorage.setItem("language", language);
      },
      // 获取菜单列表
      getMenuRounters() {
        let params = {
          url: this.$request.url.login.getMenuRounters
        }
        this.$request.get(params, (type, response) => {
          if (type == 0) {
            const menuList = response.data || [];
            const tabMenuList = [];
            menuList.forEach((menuItem) => {
              if (menuItem.meta && menuItem.children && menuItem.children.length > 0) {
                const children = [];
                tabMenuList.push({
                  name: menuItem.meta.title,
                  path: "",
                  code: menuItem.component,
                  icon: menuItem.meta.icon,
                  type: "menu",
                  children: children
                });
                menuItem.children.forEach((item) => {
                  children.push({
                    name: item.meta.title,
                    path: item.path,
                    code: item.component,
                    type: "page"
                  })
                })
              } else if (!menuItem.meta && menuItem.children && menuItem.children.length > 0) {
                tabMenuList.push({
                  name: menuItem.children[0].meta.title,
                  path: menuItem.children[0].path,
                  code: menuItem.children[0].component,
                  icon: menuItem.children[0].meta.icon,
                  type: "page"
                })
              }
            });
            this.$utils.saveMenuList(tabMenuList);
          }
        });
      },
      // 获取按钮列表
      getRoutersMenu() {
        let params = {
          url: this.$request.url.login.getRoutersMenu
        }
        this.$request.get(params, (type, response) => {
          if (type == 0) {
            const buttonPermissionList = response.data || [];
            this.$utils.saveButtonPermission(buttonPermissionList);
          }
        });
      }
    }
  }
</script>

<style>
  * {
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0) !important;
    margin: 0;
    padding: 0;
    font-family: "微软雅黑";
  }

  body {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0 !important;
    font-weight: 400 !important;
    overflow: hidden;
  }

  img {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }

  #app {
    height: 100%;
  }

  #app[language='zh-CN'] {
    word-break: break-all;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue